const compareLabel = (a, b) => a.label.localeCompare(b.label);

const getOptions = ({ list }) => {
    if (!list) return [];
    return Object.entries(list)
        .map(([id, el]) => ({ value: id, label: el.name }))
        .sort(compareLabel);
};

export default getOptions;
